/**
 * @file index.tsx
 *
 * @fileoverview Creates a sidebar layout.
 */
import { cva, VariantProps } from "class-variance-authority";
import React from "react";
import Grid from '../../../../02-atoms/06-layout/04-grid';
import Cell from '../../../../02-atoms/06-layout/04-grid/01-cell';
import styles from "./oneSideBar.module.scss";

const sideBarLayout = cva([styles.sidebar], {
  variants: {
    sidebarPosition: {
      left: styles.sidebarLeft,
      right: styles.sidebarRight,
    },
  },
});

export type OneSidebarLayoutProps = VariantProps<typeof sideBarLayout> & {
  /**
   * The main content area.
   */
  children: React.ReactNode;
  /**
   * The sidebar area.
   */
  sidebar: React.ReactNode;
  /**
   * The theme props is passed automatically to the component via styled components.
   *
   * @default "null"
   */
  theme: any;
  /**
   * The default gap for the main content to the sidebar form the scales of the theme.
   *
   * @default "7"
   */
  gap?: number;
};

/**
 * Layout with one sidebar.
 */
export const OneSidebarLayout: any = ({
  children,
  sidebar,
  sidebarPosition = "left",
  gap = 7,
}: OneSidebarLayoutProps) => (
  <Grid
    className={sideBarLayout({
      sidebarPosition: sidebar ? sidebarPosition : null, // if there is no sidebar content sidebar position is irrelevant.
    })}
    gap={gap}
  >
    {sidebarPosition === "left" && sidebar && (
      <Cell gridArea="sidebar">{sidebar}</Cell>
    )}
    <Cell gridArea="content">{children}</Cell>
    {sidebarPosition === "right" && sidebar && (
      <Cell gridArea="sidebar">{sidebar}</Cell>
    )}
  </Grid>
);
